import React, {useEffect} from 'react';
import {
  Container,
  PaymentMethodInfo,
  PaymentTitle,
  PaymentTitleRow,
  PaymentValue,
  PaymentSubtitle,
  Payment,
  BrandContainer,
  CheckIcon,
  PaymentMethod,
} from './styles';
import {RFValue} from 'react-native-responsive-fontsize';
import analytics from '@react-native-firebase/analytics';

import {Baratinhaz} from '../../../Interface/Baratinhaz';
import {PodeResgatarBaratinhasDTO} from '../../../../dtos/PodeResgatarBaratinhasDTO';
import {parseValorResgate} from '../../../../utils/payments/baratinhas';

type Props = {
  usaBaratinhas: boolean;
  descontoBaratinhas: number;
  resgate: PodeResgatarBaratinhasDTO | null;
  isLoading: boolean;
  handleAplicaBaratinhas: (value: boolean) => void;
  handleRemoveBaratinhas: () => void;
  handleSetDescontoBaratinhas: (desconto: number) => void;
};

export function PaymentBaratinhasMethodItem({
  usaBaratinhas,
  resgate,
  isLoading,
  handleAplicaBaratinhas,
  handleRemoveBaratinhas,
  handleSetDescontoBaratinhas,
}: Props) {
  async function handlePaymentMethod() {
    if (!resgate?.pode_resgatar) {
      return;
    }

    await analytics().logEvent('select_content', {
      content_type: 'pagar_com_baratao',
      item_id: 'abcd',
    });

    const proximoValor = !usaBaratinhas;
    handleAplicaBaratinhas(proximoValor);
    handleSetDescontoBaratinhas(
      proximoValor ? parseValorResgate(resgate.valor_resgate) : 0,
    );
  }

  useEffect(() => {
    handleRemoveBaratinhas();
  }, []);

  const buttonIsEnabled = !!resgate?.pode_resgatar;

  return (
    <Container
      accessibilityRole="button"
      activeOpacity={1}
      testID="Baratinhas"
      onPress={handlePaymentMethod}
      disabled={!buttonIsEnabled && !isLoading}>
      <PaymentMethod>
        <Payment>
          <BrandContainer>
            <Baratinhaz width={RFValue(20)} height={RFValue(20)} />
          </BrandContainer>
          <PaymentMethodInfo>
            <PaymentTitleRow>
              <PaymentTitle>Você possui</PaymentTitle>
              <PaymentValue>
                {isLoading ? '••••' : resgate?.quantidade}
              </PaymentValue>
              <PaymentTitle>baratinhaZ</PaymentTitle>
            </PaymentTitleRow>
            <PaymentSubtitle>
              Valor máximo:{' '}
              {isLoading ? '••••' : resgate?.minimo + ' btz'}
              {' / '}
              {isLoading ? '••••' : resgate?.valor_resgate}
            </PaymentSubtitle>
          </PaymentMethodInfo>
        </Payment>
        <CheckIcon
          name={usaBaratinhas ? 'dot-circle' : 'circle'}
          check={usaBaratinhas}
          style={{opacity: buttonIsEnabled && !isLoading ? 1 : 0.4}}
        />
      </PaymentMethod>
    </Container>
  );
}
